import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAddReactions = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M26 20H34",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30 16V24",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M13.9592 22.9763C12.8032 22.9763 11.8038 22.3083 11.3244 21.3376H9.28412C9.85204 23.3867 11.7292 24.8913 13.9592 24.8913C16.189 24.8913 18.0663 23.3867 18.6342 21.3376H16.5938C16.1144 22.3083 15.115 22.9763 13.9592 22.9763Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M13.9592 26.011C10.6169 26.011 7.90744 23.3014 7.90744 19.9592C7.90744 16.6168 10.6169 13.9074 13.9592 13.9074C16.8556 13.9074 19.2754 15.9426 19.8698 18.6607H21.8123C21.1923 14.8826 17.9126 12 13.9592 12C9.56344 12 6 15.5634 6 19.9592C6 24.3549 9.56344 27.9183 13.9592 27.9183C17.9126 27.9183 21.1923 25.0356 21.8123 21.2576H19.8698C19.2754 23.9757 16.8556 26.011 13.9592 26.011Z",
			fill: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgAddReactions);
export default ForwardRef;
